module.exports = __webpack_public_path__ + "static/img/404.3e72586.png";